import enumerate from 'lib/enumerate';

export const ActionTypes = enumerate([
  'APPEND_MEMBERS',
  'CREATE_CHAT',
  'DEACTIVATE',
  'DESTROY_LOCAL_CHAT',
  'FILTER_BY_GROUP',
  'JOIN_CHAT',
  'LEAVE_CHAT',
  'LIST_CHATS',
  'LOAD_CHAT',
  'UPDATE_CHATS_MESSAGES',
  'LOAD_CHAT_MESSAGES',
  'LOAD_GAP_MESSAGE',
  'LOAD_LOCAL_CHAT',
  'UPDATE_LOCAL_CHAT',
  'LOAD_MEMBERS',
  'MARK_READ',
  'MESSAGE_FAILED',
  'REMOVE_MEMBERS_FROM_CHAT',
  'READ_MESSAGE',
  'REMOVE_GROUPS',
  'REMOVE_MESSAGE',
  'RESET_STORE',
  'ADD_MEMBERS_TO_CHAT',
  'ENABLE_REPLIES_CHAT',
  'EDIT_MEMBER_FROM_CHAT',
  'DISABLE_REPLIES_CHAT',
  'SELECT_CHAT',
  'RESET_SELECTION',
  'SEND_MESSAGE',
  'SENT_MESSAGE',
  'UPDATE_CHAT',
  'UPDATE_MEMBER',
  'APPEND_CHATS',
  'SET_FOCUS_VIEW',
  'SEARCH_CHATS',
  'START_PHONE_CALL',
]);

export const FocusableViews = enumerate(['NONE', 'COMPOSER', 'HEADER']);

export const DATA_RELOAD_TIMEOUT_MS = 5 * 60 * 1000; // 5 minutes

export const SEARCH_UI_LIMIT_MS = 150;

export const PUSH_BATCHING_WINDOW_MS = 1000;

/**
 * Limit network request frequency so that serial requests (e.g. q=t, q=tu, q=tur)
 * don't waste bandwidth and CPU
 */
export const SEARCH_NETWORK_LIMIT_MS = 300;

export const SKIP_URGENT_MESSAGING_INFO_DIALOG_COOKIE = 'skipUrgentMessagingInfoDialog';

export default {
  ActionTypes,
  FocusableViews,
  DATA_RELOAD_TIMEOUT_MS,
  SEARCH_UI_LIMIT_MS,
  SEARCH_NETWORK_LIMIT_MS,
  SKIP_URGENT_MESSAGING_INFO_DIALOG_COOKIE,
};

export const CHATS_PAGE_SIZE = 8;
